import { Control } from "../Control.js";

export class Button extends Control {

    constructor(parent, options = {}) {

        super(parent, options);

        const {
            label = null,
            hint = null,
            icon = null,
            size = 'normal',
            style = 'button',
            group = null,
            primary = false,
            onClick = null
        } = options;

        this.label = label;
        this.hint = hint;
        this.icon = icon;
        this.size = size;
        this.style = style;
        this.group = group;
        this.primary = primary;
        this.onClick = onClick;

    };

    getLabel() { return (typeof this.label === 'function') ? this.label.call(this) : this.label; };

    getIcon() { return (typeof this.icon === 'function') ? this.icon.call(this) : this.icon; };

    getHint() { return (typeof this.hint === 'function') ? this.hint.call(this) : this.hint; };

    getSize() { return (typeof this.size === 'function') ? this.size.call(this) : this.size; };

    getStyle() { return (typeof this.style === 'function') ? this.style.call(this) : this.style; };

    isPrimary() { return (typeof this.primary === 'function') ? this.primary.call(this) : this.primary; };

    _render(r, vm) {

        if (!this.isVisible())
            return null;

        const renderer = r;

        var label = this.getLabel(),
            icon = this.getIcon(),
            css = this.getCss() || '',
            props = {
                id: this.getId(),
                title: this.getHint(),
                disabled: (this.isDisabled() || this.isReadOnly()) ? 'disabled' : null,
                group: this.group,
                onclick: this.onClick
            },
            options = {
                css,
                props,
                primary: this.isPrimary(),
                size: this.getSize(),
                style: this.getStyle(),
            };

        return renderer.button(label, icon, options);

    }

}